import { useOutletContext, useParams } from 'react-router-dom'
import { Ticket } from './Ticket'
const benefits = [
   'Access to Panels',
   'Access to Workshops',
   'Access to Startup Pitches',
   'Dedicated Networking Breaks',
   'Discounted Hotel Rates \n *While they last',
   'Opening Reception Ticket',
   'Access to Matchmaking',
   'Access to Event App',
   'Digital Event Guide',
   'Snacks and Drinks',
   'Lunch',
   'Email Support',
   'Early Access to Networking \n *7 days before Gold ticket holders',
   'VIP Seating | Main Stage',
   'Discount for Additional Tickets',
   'Phone Support',
]

const tickets = {
   startups: [
      {
         name: 'Silver',
         price: 797,
         bgColor: 'linear-gradient(180deg, #2029FF 0%, #1F3776 99.99%)',
         benefits: benefits.slice(0, 5),
         widgetId: 291230,
      },
      {

         name: 'Gold',
         price: 897,
         bgColor: 'linear-gradient(180deg, #0008C5 0%, #001C64 99.99%)',
         benefits: benefits.slice(0, 12),
         widgetId: 291231,
      },
      {

         name: 'Platinum',
         price: 1697,
         bgColor: 'linear-gradient(180deg, #2029FF 0%, #1F3776 99.99%)',
         benefits: benefits.slice(0, 16),
         widgetId: 291232,

      },
   ],
   investors: [
      {
         name: 'Silver',
         price: 897,
         bgColor: 'linear-gradient(180deg, #106B2A 0%, #457C55 100%)',
         benefits: benefits.slice(0, 5),
         widgetId: 291233,

      },
      {
         name: 'Gold',
         price: 997,
         bgColor: 'linear-gradient(180deg, #014408 0%, #0D782B 100%)',
         benefits: benefits.slice(0, 12),
         widgetId: 291234,

      },
      {
         name: 'Platinum',
         price: 1797,
         bgColor: 'linear-gradient(180deg, #106B2A 0%, #457C55 100%)',
         benefits: benefits.slice(0, 16),
         widgetId: 291235,
      },
   ],
   general: [
      {
         name: 'Silver',
         price: 997,
         bgColor: 'linear-gradient(180deg, #312948 0%, #7E5FD6 100%)',
         benefits: benefits.slice(0, 5),
         widgetId: 291236,
      },
      {
         name: 'Gold',
         price: 1097,
         bgColor: 'linear-gradient(180deg, #200C57 0%, #4F1DDD 100%)',
         benefits: benefits.slice(0, 12),
         widgetId: 291237,
      },
      {
         name: 'Platinum',
         price: 2297,
         bgColor: 'linear-gradient(180deg, #312948 0%, #7E5FD6 100%)',
         benefits: benefits.slice(0, 16),
         widgetId: 291238,
      },
   ],
}

export const Tickets = () => {
   const { type } = useParams()
   const [DISCOUNT] = useOutletContext()

   return (
      <div key={type} className='tickets-benefits'>
         <section className='benefits' style={{ background: tickets[type][0].bgColor }}>
            <ul>
               {
                  benefits.map((benefit, index) =>
                     <li key={index}>{benefit}</li>
                  )
               }
            </ul>
         </section>
         <section className='tickets' >
            {
               tickets[type].map((ticket, index) =>
                  <Ticket key={index} type={type} ticket={ticket} benefits={benefits} discount={DISCOUNT} />
               )
            }
         </section>
      </div>
   )
}